import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LauftextComponent } from './lauftext.component';
import { AngularMaterialModule } from '../../material.module';

@NgModule({
    declarations: [LauftextComponent],
    imports: [
        CommonModule,
        AngularMaterialModule
    ],
    exports: [
        LauftextComponent
    ]
})
export class LauftextModule { }
